export const API = {
	PROD: "https://crm.classplus.co/growth/careersPage",
};
